import React from 'react';

import styles from './BotAvatar.module.scss';

export const BotAnimated = () => {
  return (
    <div className={styles.bot__container}>
      <div id={styles.chatbot}>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
        <div className={styles.dot}></div>
      </div>
      <div id={styles.chatbot__corner}></div>
      <div id={styles.antenna}>
        <div id={styles.beam}></div>
        <div id={styles.beam__pulsar}></div>
      </div>
    </div>
  );
};

function BotAvatar() {
  return (
    <div className={styles.bot__wrapper}>
      <BotAnimated />
    </div>
  );
}

export default BotAvatar;
